'use strict';

import React from 'react';
import LiveInternet from '../Metric/LiveInternet';
import { getSearchUrl as _ } from '../../utils/urls';
import { SALE, RENT, RENTDAILY, APARTMENTS, LANDS, COMMERCIALS, GARAGES } from '../../consts';
import {
  SALE_APARTMENTS_1_ROOM, SALE_APARTMENTS_2_ROOM,
  RENT_APARTMENTS_1_ROOM, RENT_APARTMENTS_2_ROOM,
  RENT_APARTMENTS_COTTAGE, RENTDAILY_COTTAGE,
  SALE_APARTMENTS_NEWBUILDING,
  RESIDENTIAL_COMPLEX, COTTAGE_VILLAGE
} from '../../utils/aliases';


export default function Footer (props) {
  return (
    <footer className='main-footer no-print'>
      <div className='container' >
        <table>
          <tbody>
            <tr>
              <th>Продажа</th>
              <th>Аренда</th>
              <th>Новостройки</th>
              <th>Дополнительно</th>
            </tr>

            <tr>
              <td>
                <ul>
                  <li>
                    <a href={_(SALE, APARTMENTS)}>Квартиры, комнаты</a>
                  </li>
                  <li>
                    <a href={SALE_APARTMENTS_1_ROOM}>Однокомнатные</a>
                  </li>
                  <li>
                    <a href={SALE_APARTMENTS_2_ROOM}>Двухкомнатные</a>
                  </li>
                  <li>
                    <a href={_(SALE, LANDS)}>Дома, участки, дачи</a>
                  </li>
                  <li>
                    <a href={_(SALE, COMMERCIALS)}>Коммерческая недвижимость</a>
                  </li>
                  <li>
                    <a href={_(SALE, GARAGES)}>Гаражи</a>
                  </li>
                </ul>
              </td>

              <td>
                <ul>
                  <li>
                    <a href={_(RENT, APARTMENTS)}>Снять квартиру</a>
                  </li>
                  <li>
                    <a href={RENT_APARTMENTS_1_ROOM}>Однокомнатные</a>
                  </li>
                  <li>
                    <a href={RENT_APARTMENTS_2_ROOM}>Двухкомнатные</a>
                  </li>
                  <li>
                    <a href={RENT_APARTMENTS_COTTAGE}>Аренда коттеджей</a>
                  </li>
                  <li>
                    <a href={_(RENTDAILY, APARTMENTS)}>Квартиры посуточно</a>
                  </li>
                  <li>
                    <a href={RENTDAILY_COTTAGE}>Коттеджи посуточно</a>
                  </li>
                  <li>
                    <a href={_(RENT, COMMERCIALS)}>Коммерческая недвижимость</a>
                  </li>
                </ul>
              </td>

              <td>
                <ul>
                  <li>
                    <a href={RESIDENTIAL_COMPLEX}>Жилые комплексы</a>
                  </li>
                  <li>
                    <a href={SALE_APARTMENTS_NEWBUILDING}>Квартиры в новостройках</a>
                  </li>
                  <li>
                    <a href={COTTAGE_VILLAGE}>Коттеджные посёлки</a>
                  </li>
                </ul>
              </td>

              <td>
                <ul>
                  <li><a href='/rieltory/'>Риэлторы</a></li>
                  <li><a href='/agentstva/'>Агентства</a></li>
                  <li><a href='/agentstva/?SearchAgency%5Bcategory%5D=building'>Застройщики</a></li>
                  <li><a href='/page/declaration/index/'>Проектные декларации</a></li>
                  <li><a href='/office/vacancy/index/'>Вакансии агентств</a></li>
                  <li><a href='/office/statistic/'>Цены</a></li>
                </ul>
              </td>

            </tr>
          </tbody>
        </table>

        <ul className='horizontal-nav'>
          <li><a href='/page/default/price/'>Реклама на сайте</a></li>
          <li><a href='/billing/default/pays/'>Способы оплаты</a></li>
          <li><a href='/page/feedback/index/'>Техподдержка</a></li>
          <li><a href='/page/default/contacts/'>Контакты</a></li>
          <li><a href='/page/default/rules/'>Правила</a></li>
        </ul>

        <ul className='horizontal-nav social-links'>
          <li>
            <span className='copyright'>© МЛСН.ру - недвижимость в Омске</span>
          </li>
          <li>
            <a className='social-link' rel='nofollow' target='_blank' href='https://vk.com/mlsn.omsk'>
              <i className='icon-vk-flat' /> Вконтакте
            </a>
          </li>
          <li>
            <a className='social-link' rel='nofollow' target='_blank' href='https://www.youtube.com/channel/UC-Cys8dOCX34H1QHpLe0T1g/videos'>
              <i className='icon-youtube-flat' /> YouTube
            </a>
          </li>
        </ul>

        <div style={{position: 'relative'}}>
          <ul className='horizontal-nav mobile-links'>
            <li>
              <a href='https://m.mlsn.ru'>
                <div className='app-icon icon-mobile-web'>&nbsp;</div>
              </a>
            </li>
            {/* <li>
              <a rel='nofollow' target='_blank' href='https://itunes.apple.com/ru/app/mlsn.ru-nedvizimost/id1039815631'>
                <div className='app-icon icon-apple-store'>&nbsp;</div>
              </a>
            </li>
            <li>
              <a rel='nofollow' target='_blank' href='https://play.google.com/store/apps/details?id=ru.mlsn.realty'>
                <div className='app-icon icon-google-play'>&nbsp;</div>
              </a>
            </li> */}
          </ul>

          <div className='counter'>
            <div className='live-internet'>
              <LiveInternet
                isRealtor
                cityId={55}
              />
            </div>
            <div className='icon-six-plus-sign' data-tip data-for='tip-six-plus'>
              <span className='page-footer-age__tip'>
                <p>Некоторые материалы настоящего раздела могут содержать информацию, запрещенную для детей, не&nbsp;достигших шести лет.</p>
                <p>Информация о&nbsp;возрастных ограничениях в&nbsp;отношении информационной продукции, подлежащая распространению на&nbsp;основании норм Федерального закона
                  «О&nbsp;защите детей от&nbsp;информации, причиняющей вред их&nbsp;здоровью и&nbsp;развитию».</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/ui/Footer/index.js